export const GET_MASTER_SLAVE_SUCCESS = 'GET_MASTER_SLAVE_SUCCESS';
export const SELECT_MASTER_SLAVE_SUCCESS = 'SELECT_MASTER_SLAVE_SUCCESS';
export const SET_IS_GLOBAL_MODE = 'SET_IS_GLOBAL_MODE';
export const SET_CLIENT_TOKEN = 'SET_CLIENT_TOKEN';
export const RESET_STORE = 'RESET_STORE';
